import { Point3D } from '../../team-apis/otterdam/answers/shape-typings';
import { CameraType } from '../render/cameras/switchable-camera';

export class CameraState {
  type: CameraType = 'perspective';

  constructor(
    public position: Point3D,
    public target: Point3D,
  ) {}
}
